export const VACATION_REQUESTS_STRINGS = {
  TITLE: "Solicitudes de Vacaciones",
  HUMAN_RESOURCES_LABEL: "Recursos Humanos",

  BUTTON_UPDATE_LABEL: "Actualizar Datos",

  TEXT_TOOLTIP_APPROVE: "Aprobar solicitud",
  TEXT_TOOLTIP_APPLY: "Aplicar solicitud",
  TEXT_TOOLTIP_REJECT: "Rechazar solicitud",
  TEXT_TOOLTIP_DETAIL: "Mostrar detalle",

  TEXT_TABLE_RESULTS:
    "Mostrando {first} a {last} de {totalRecords} solicitudes",

  EXPORT_NO_DATA: "No hay solicitudes para exportar a Excel.",
  EXPORT_SUCCESS: "Las solicitudes se han exportado a Excel correctamente.",
  EXPORT_ERROR:
    "Error al exportar las solicitudes a Excel. Por favor, intente nuevamente.",

  GET_DATA_ERROR_TITLE: "Error al obtener las solicitudes de vacaciones.",
  GET_DATA_PERIOD_ERROR_TITLE: "Error al obtener los tipos de periodo.",
  IMPORT_PERIOD_ERROR_TITLE: "Error al importar los periodos.",
  UPDATE_DATA_ERROR_TITLE: "Error al actualizar la solicitud",
  UPDATE_DATA_WARNING_TITLE:
    "Error al actualizar las solicitudes de vacaciones.",
  UPDATE_DATA_WARNING_MESSAGE:
    "No se pueden actualizar los datos debido a un error al obtener las solicitudes de vacaciones. Por favor, intente nuevamente.",
  UPDATE_DATA_SUCCESS_TITLE:
    "Las solicitudes de vacaciones se han actualizado correctamente.",
  UPDATE_PARTIAL_FAILURE_TITLE:
    "Algunas solicitudes no pudieron ser actualizadas.",

  EMPTY_REQUEST_TO_APPROVE_WARNING_TITLE:
    "Primero debe seleccionar las solicitudes a aprobar",
  EMPTY_REQUEST_TO_WARNING_TITLE:
    "Primero debe seleccionar las solicitudes a rechazar",

  APPLY_BUTTON_TOOLTIP: "Aplicar solicitudes en la nómina",
  EMPTY_REQUEST_TO_APPLY_WARNING:
    "Seleccione las solicitudes que desea aplicar",
  APPLY_CONFIRM_TITLE: "Aplicar al sistema base",
  APPLY_CONFIRM_MESSAGE_SINGULAR:
    "Se aplicará 1 solicitud al sistema base. Esta acción no se puede deshacer. ¿Deseas continuar?",
  APPLY_CONFIRM_MESSAGE_PLURAL:
    "Se aplicarán {n} solicitudes al sistema base. Esta acción no se puede deshacer. ¿Deseas continuar?",
  APPLY_CONFIRM_AGREE_LABEL: "Continuar",
  APPLY_RESULT_TITLE: "Resultado de la aplicación",
  APPLY_RESULT_HEADER_TEMPLATE: "{ok} aplicadas · {err} con error",
  APPLY_RESULT_COLUMN_COLLABORATOR: "Colaborador",
  APPLY_RESULT_COLUMN_TYPE: "Tipo",
  APPLY_RESULT_COLUMN_STATUS: "Estado",
  APPLY_RESULT_COLUMN_MESSAGE: "Detalle",
  APPLY_RESULT_OK_LABEL: "Aplicada",
  APPLY_RESULT_ERROR_LABEL: "Error",
  APPLY_RESULT_CLOSE_LABEL: "Cerrar",
  APPLY_SUCCESS_ALL: "Las solicitudes se han aplicado correctamente",
  APPLY_PARTIAL: "Algunas solicitudes no se pudieron aplicar",
  APPLY_ERROR_TITLE: "Error al aplicar las solicitudes",

  DETAIL_TITLE: "Detalle de solicitud",
  DETAIL_SHIFT_LABEL: "Turno:",
  DETAIL_CODE_LABEL: "Código:",
  DETAIL_DAYS_LABEL: "Días solicitados:",
  PROCESSED_BY_LABEL: "Responsable:",
  DETAIL_DAYS_NOT_CONSIDERED_LABEL: "Días no considerados:",
  DETAIL_AVAILABLE_BALANCE_LABEL: "Saldo disponible:",
  DETAIL_REMAINING_BALANCE_LABEL: "Saldo restante:",
  DETAIL_REASON_LABEL: "Motivo:",
  DETAIL_CREATED_DATE_LABEL: "Fecha de creación:",
  DETAIL_COMMENTS_LABEL: "Comentarios:",
  DETAIL_REJECT_SUCCESS_LABEL: "Solicitud rechazada",
  DETAIL_APPROVE_SUCCESS_LABEL: "Solicitud aprobada",
  DETAIL_APPLY_SUCCESS_LABEL: "Solicitud aplicada",
  DETAIL_REJECT_ERROR_LABEL: "No se pudo rechazar la solicitud",
  DETAIL_APPROVE_ERROR_LABEL: "No se pudo aprobar la solicitud",
  DETAIL_APPLY_ERROR_LABEL: "No se pudo aplicar la solicitud",
  OVERLAPPING_SECTION_TITLE: "Otras personas en los mismos días de ausencia",

  FILES_SECTION_TITLE: "Archivos adjuntos",
  FILES_VIEW_BUTTON_LABEL: "Ver archivo",
  FILES_DOWNLOAD_BUTTON_LABEL: "Descargar archivo",

  DETAIL_ERROR_MESSAGE: "Error al cargar el detalle de la solicitud.",
  FILES_ERROR_MESSAGE: "Error al cargar los archivos adjuntos de la solicitud.",

  FILES_DOWNLOAD_ERROR_TITLE: "Error al descargar el archivo adjunto.",
} as const;
